import {
    MapContainer,
    TileLayer,
    Marker,
    Polyline,
    ZoomControl,
    useMap
} from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useState, useContext } from 'react';
import { contexto } from "./CustomProvider";

import 'leaflet/dist/leaflet.css';

/* Fix para los íconos por defecto de Leaflet en React */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

/* Ícono de la ISS */
const issIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/International_Space_Station.svg',
    iconSize: [50, 32],
    iconAnchor: [25, 16],
});

/* Componente interno para re-centrar y corregir el tamaño del mapa */
function ChangeView({ center, zoom }) {
    const map = useMap();

    useEffect(() => {
        setTimeout(() => {
            map.invalidateSize({ animate: true });
        }, 400);

        map.setView(center, zoom);
    }, [center, zoom, map]);

    return null;
}

export default function ISSTracker() {
    const { thisDeviceData } = useContext(contexto);
    const userLocation = thisDeviceData?.location;

    const userPosition = userLocation
        ? [userLocation.latitude, userLocation.longitude]
        : null;

    const [issPosition, setIssPosition] = useState(null);
    const [path, setPath] = useState([]);

    useEffect(() => {
        const fetchISS = async () => {
            try {
                const res = await fetch('https://api.wheretheiss.at/v1/satellites/25544');
                const data = await res.json();
                const { latitude, longitude } = data;

                setIssPosition([latitude, longitude]);
                setPath(prev => [...prev, [latitude, longitude]].slice(-120));
            } catch (error) {
                console.error("Error buscando la ISS:", error);
            }
        };

        fetchISS();
        const interval = setInterval(fetchISS, 15 * 1000);
        return () => clearInterval(interval);
    }, []);

    if (!issPosition) {
        return (
            <div style={{ color: 'white', padding: '20px' }}>
                Localizando ISS...
            </div>
        );
    }

    return (
        <div style={{ height: '100%', width: '100%', background: '#000' }}>
            <MapContainer
                center={issPosition}
                zoom={3}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={false}
                zoomControl={false}
            >
                <TileLayer
                    attribution="&copy; OpenStreetMap"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <ZoomControl position="bottomright" />

                <ChangeView center={issPosition} zoom={3} />

                {/* ISS */}
                <Marker position={issPosition} icon={issIcon} />

                <Polyline
                    positions={path}
                    pathOptions={{ color: '#ff6600', weight: 2, opacity: 0.6 }}
                />

                {/* Usuario */}
                {userPosition && (
                    <Marker position={userPosition} />
                )}
            </MapContainer>
        </div>
    );
}
